// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DweEFaF5owOe02 {
  align-items: center;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 0;
  border-radius: 100%;
  box-sizing: border-box;
  color: var(--ds-icon, #44546f);
  display: inline-flex;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 12px;
  font-weight: bold;
  justify-content: center;
  line-height: 28px;
  opacity: 1;
  height: 28px;
  width: 28px;
  max-width: 128px;
  max-height: 128px;
  overflow: hidden;
  white-space: nowrap;
  -webkit-print-color-adjust: exact;
}
.DweEFaF5owOe02.pDQ13XeuqNHubf {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-icon-subtle, #626f86);
}
.DweEFaF5owOe02.TJUpPn0jtraRiv {
  color: var(--ds-text-subtle, #44546f);
}
.DweEFaF5owOe02.yx5_x_4I9Oxa31 {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  border: 1px solid var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.DweEFaF5owOe02.yx5_x_4I9Oxa31.pDQ13XeuqNHubf {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.aAavNeba2Z7ob4.DweEFaF5owOe02 {
  margin-left: 4px;
  margin-top: 4px;
  float: right;
}
.FZeOmAUAJECpqh.DweEFaF5owOe02 {
  align-self: flex-start;
  flex: 0 0 auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `DweEFaF5owOe02`,
	"deactivated": `pDQ13XeuqNHubf`,
	"isGhost": `TJUpPn0jtraRiv`,
	"lightBackground": `yx5_x_4I9Oxa31`,
	"cardFront": `aAavNeba2Z7ob4`,
	"detailHeader": `FZeOmAUAJECpqh`
};
export default ___CSS_LOADER_EXPORT___;
